import styled from 'styled-components';
import { color, compose, flexbox, layout, space, typography } from 'styled-system';

// Drop-in replacement for reflexbox/styled-components Box and Flex:
// same styled-system prop set in the same compose order.
export const Box = styled.div(
  {
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0,
  },
  compose(space, layout, typography, color, flexbox),
);

export const Flex = styled(Box)({
  display: 'flex',
});
